import { apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { CurrenciesPositionReport } from '../types';

export const currenciesPositionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCurrenciesPositionReport: build.query<
      { data: CurrenciesPositionReport },
      string
    >({
      query: (query) => ({
        url: `/v1/reports/currency-position${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),

    exportCurrenciesPositionReport: build.mutation<
      any,
      { transferDateFrom?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/currency-position/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useExportCurrenciesPositionReportMutation,
  useLazyGetCurrenciesPositionReportQuery,
} = currenciesPositionApi;

export const {
  endpoints: { getCurrenciesPositionReport, exportCurrenciesPositionReport },
} = currenciesPositionApi;
